import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import deepEqual from 'fast-deep-equal';
import { LayoutSession } from '@jbrowse/core/pluggableElementTypes/renderers/BoxRendererType';
import { readConfObject } from '@jbrowse/core/configuration';
// Sorting and revealing soft clip changes the layout of Pileup renderer
// Adds extra conditions to see if cached layout is valid
export var PileupLayoutSession = /*#__PURE__*/function (_LayoutSession) {
  _inherits(PileupLayoutSession, _LayoutSession);
  function PileupLayoutSession(args) {
    var _this;
    _classCallCheck(this, PileupLayoutSession);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(PileupLayoutSession).call(this, args));
    _this.showSoftClip = false;
    _this.config = args.config;
    return _this;
  }
  _createClass(PileupLayoutSession, [{
    key: "cachedLayoutIsValid",
    value: function cachedLayoutIsValid(cachedLayout) {
      return _get(_getPrototypeOf(PileupLayoutSession.prototype), "cachedLayoutIsValid", this).call(this, cachedLayout) && this.showSoftClip === cachedLayout.showSoftClip && deepEqual(this.sortedBy, cachedLayout.sortedBy) && deepEqual(this.filterBy, cachedLayout.filterBy);
    }
  }, {
    key: "layout",
    get: function get() {
      if (!this.cachedLayout || !this.cachedLayoutIsValid(this.cachedLayout)) {
        this.cachedLayout = {
          layout: this.makeLayout(),
          config: readConfObject(this.config),
          filters: this.filters,
          filterBy: this.filterBy,
          sortedBy: this.sortedBy,
          showSoftClip: this.showSoftClip
        };
      }
      return this.cachedLayout.layout;
    }
  }]);
  return PileupLayoutSession;
}(LayoutSession);